<template>
  <el-tree
    v-loading="loading"
    style="max-height: 300px; overflow-y: auto"
    ref="menuSelectTree"
    :data="menuList"
    :accordion="false"
    :props="{
      label: 'menuName',
    }"
    node-key="id"
    :expand-on-click-node="false"
    highlight-current
    default-expand-all
    check-on-click-node
    show-checkbox
    @check="handleCheck"
  ></el-tree>
</template>

<script>
export default {
  name: "MenuTreeMultiSelect",
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    containTopNode: {
      type: Boolean,
      default: false,
    },
    containFrozen: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: {
      handler(val) {
        var that = this;
        this.value.forEach((i, n) => {
          var node = that.$refs.menuSelectTree.getNode(i);
          if (node && (!node.children || node.children.length == 0)) {
            that.$refs.menuSelectTree.setChecked(node, true);
          }
        });
      },
      immediate: true,
    },
  },
  data() {
    return {
      loading: false,
      menuList: [],
    };
  },
  methods: {
    async flushData() {
      this.loading = true;
      let requestRes = this.containFrozen
        ? await this.$api.sysMenu_findAllTree({
            showLoading: false,
          })
        : await this.$api.sysMenu_findUnFrozenTree({
            showLoading: false,
          });
      if (requestRes && requestRes.success) {
        this.menuList = this.containTopNode
          ? [].concat({
              ...this.$jsTool.topMenu(),
              children: requestRes.data,
            })
          : requestRes.data;
        this.$nextTick(() => {
          let that = this;
          this.value.forEach((i, n) => {
            var node = that.$refs.menuSelectTree.getNode(i);
            if (node && (!node.children || node.children.length == 0)) {
              that.$refs.menuSelectTree.setChecked(node, true);
            }
          });
        });
      }
      setTimeout(() => {
        this.loading = false;
      }, 200);
    },
    handleCheck(a, b) {
      this.$emit("check", b);
    },
  },
  async mounted() {
    await this.flushData();
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/MenuTreeMultiSelect.vue